import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=90d1fccc&scoped=true"
import script from "./Overview.vue?vue&type=script&setup=true&lang=js"
export * from "./Overview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Overview.vue?vue&type=style&index=0&id=90d1fccc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d1fccc",
  null
  
)

export default component.exports